import {createReducer, on} from '@ngrx/store';
import * as CreateOrganizationActions from '../actions/create-organization.actions';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const createOrganizationFeatureKey = 'createOrganization';

export interface State {
  record: Organization | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(CreateOrganizationActions.createOrganization, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true
  })),
  on(CreateOrganizationActions.createOrganizationSuccess, (_state: State, action: { data: Organization }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(CreateOrganizationActions.createOrganizationFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(CreateOrganizationActions.clearCreateOrganizationState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

